import { Component, EventEmitter, Output } from '@angular/core';
import { DatosDocumentosService } from '../../services/datos-documentos.service';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { TipoFiltro } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/tipo-filtro';

@Component({
  selector: 'app-documentos-filtros-nuevos',
  templateUrl: './documentos-filtros-nuevos.component.html',
  styleUrls: ['./documentos-filtros-nuevos.component.css']
})
export class DocumentosFiltrosNuevosComponent {

  tipoDocs: DesplegableData[] = [];
  tipoDocSeleccionado: DesplegableData | undefined;
  @Output() filtrarDocumentos: EventEmitter<FiltroSqp> = new EventEmitter<FiltroSqp>();

  constructor(private datosDocumentosService: DatosDocumentosService) {
                this.getTipoDocumentosLista();
              }

  ngOnInit(): void {
    this.seleccionarValorInicial();
    this.actualizaFiltroTipoDocumento(this.tipoDocSeleccionado);
  }

  getTipoDocumentosLista(){
    this.tipoDocs  = this.datosDocumentosService.GetTipoDocumentosLista();
  }

  private seleccionarValorInicial(): void {
    if(this.datosDocumentosService.filtros.length > 0){
      const filtroTipoDoc = this.datosDocumentosService.filtros.find(x => x.text === 'Tipo documento');
      if(filtroTipoDoc){
        if(filtroTipoDoc.tipoDoc === 'TODOS'){
          this.tipoDocSeleccionado = this.tipoDocs.find(tipo => tipo.desc === 'Todos los tipos documento') || this.tipoDocs[0];
        } else {
          this.tipoDocSeleccionado = this.tipoDocs.find(tipo => tipo.desc === filtroTipoDoc.tipoDoc) || this.tipoDocs[0];
        }
      } else {
        this.tipoDocSeleccionado = this.tipoDocs[0];
      }
    } else {
      this.tipoDocSeleccionado = this.tipoDocs[0];
    }

    this.aplicarPreseleccionTipoDocumento();
  }


  actualizaFiltroTipoDocumento(tipoDocSeleccionado: DesplegableData | undefined): void {
    if (!tipoDocSeleccionado) return;

    this.tipoDocSeleccionado = tipoDocSeleccionado;
    this.aplicarPreseleccionTipoDocumento();
    let tipo;
    if(this.tipoDocSeleccionado.desc === 'Todos los tipos documento'){
      tipo = {id:'TODOS', desc:'TODOS'}
    } else {
      tipo = this.tipoDocSeleccionado;
    }

    const filtroDocSqp: FiltroSqp = {
      titulo: 'Tipo documento',
      tipoFiltro: TipoFiltro.DESPLEGABLE_SINGLE,
      valoresSeleccionados: {
        valorString: tipo?.desc??''
      }
    }
    this.filtrarDocumentos.emit(filtroDocSqp);
  }

  private aplicarPreseleccionTipoDocumento(): void {
    const tipoDocSeleccionadoId = this.tipoDocSeleccionado?.id;
    this.tipoDocs = this.tipoDocs.map((tipo) => ({
      ...tipo,
      seleccionado: tipo.id === tipoDocSeleccionadoId
    }));
  }

}
